// api/API.js
import axios from "axios";
import { getCurrentUser, loginUser, logoutUser } from "../utility/UserUtils";

const API_BASE = process.env.REACT_APP_API_URL;

// Axios instances
const adminAPI = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // for Payload Admin-only requests
});

const memberAPI = axios.create({
  baseURL: API_BASE,
  // withCredentials: true,
});

memberAPI.interceptors.request.use((config) => {
  const user = getCurrentUser();

  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }

  return config;
});

// Member login
export const loginMember = async (email, password) => {
  const res = await memberAPI.post("/member-login", { email, password });

  if (res.data?.user && res.data?.token) {
    const userToStore = {
      ...res.data.user,
      token: res.data.token,
    };

    loginUser(userToStore);
  } else {
  }

  return res.data;
};

// Member logout
export const logoutMember = () => {
  logoutUser();
};

// CRUD HELPERS

// CREATE
export const create = async (endpoint, payload, config = {}) => {
  const res = await memberAPI.post(endpoint, payload, config);
  return res.data;
};

// READ
export const getAll = async (endpoint, params = {}) => {
  const res = await memberAPI.get(endpoint, { params });
  return res.data;
};

export const getByID = async (endpoint, id, params = {}) => {
  const res = await memberAPI.get(`${endpoint}/${id}`, { params });
  return res.data;
};

export const getByQuery = async (endpoint, query) => {
  const res = await memberAPI.get(`${endpoint}?${query}`);
  return res.data;
};

// UPDATE
export const update = async (endpoint, payload) => {
  const res = await memberAPI.patch(endpoint, payload, {
    withCredentials: true,
  });
  return res.data;
};

// PATCH (partial update)
export const patch = async (endpoint, payload, config = {}) => {
  const res = await memberAPI.patch(endpoint, payload, config);
  return res.data;
};

// Register a user after payment verification
export const registerForEvent = async (paymentDetails, eventId, member) => {
  try {
    const res = await memberAPI.post("/event-payment-verify", {
      ...paymentDetails,
      eventId,
      member: {
        id: member.id,
        firstName: member.firstName,
        lastName: member.lastName,
        email: member.email,
        cohort: member.cohort,
      },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

// Create a payment order
export const createOrder = async ({ amount, eventId }) => {
  try {
    const res = await memberAPI.post("/create-order", {
      amount,
      eventId,
      member: getCurrentUser()?.id,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};
// api/API.js (reuse)
export const completeProfile = async (memberId, payload) => {
  const res = await update(`/members/${memberId}`, payload);
  return res;
};
